import { Button, SectionSubtitle } from '@web_opxp/components';
import { ETagType, renderStringToReact, useTranslation } from '@web_opxp/language';
import { useEffect, useState } from 'react';
import { SKELETON_CLASSNAME } from '../../base/constants';
import ENV from '../../base/env';
import { redirectBackToSubscribe } from '../../base/utils';
import MoneybackGuarantee from '../../components/moneyback/MoneybackGuarantee';

export default function Cancel() {
  const illustrationSrc = `${ENV.AssetsBaseUrl}/feature/support.png`;
  const { language, t } = useTranslation();
  const [loading, setLoading] = useState(!language);
  useEffect(() => {
    setLoading(!language);
  }, [language]);
  const backHandler = () => {
    // This has to stay here
    // eslint-disable-next-line react-hooks/rules-of-hooks
    setLoading(true);
    redirectBackToSubscribe(true);
  };
  const skeletonClass = !language || loading ? SKELETON_CLASSNAME : '';
  const title = language ? t('Checkout.Cancel.Title') : '';
  const titleClass = `title ${skeletonClass}`;
  const subtitle = language ? t('Checkout.Cancel.SubtitleHtml') : '';
  const subtitleClass = skeletonClass;
  const ctaLabel = language ? t('Checkout.Cancel.CTA') : '';
  const ctaClass = skeletonClass;
  return (
    <>
      <div className="panel" data-testid="cancel-panel">
        <div className="illustration">
          <img src={illustrationSrc} alt={title} />
        </div>
        <div className="content">
          <h3 className={titleClass}>{title}</h3>
          <SectionSubtitle wrapperTag="div" className={subtitleClass}>
            {renderStringToReact(subtitle, ETagType.div)}
          </SectionSubtitle>
          <div className="buttons">
            <Button className={ctaClass} label={ctaLabel} onClick={backHandler} />
          </div>
        </div>
      </div>
      <MoneybackGuarantee />
    </>
  );
}
